import React from 'react';
import { css } from '@emotion/react';
import { OnwardLink } from '@/styles/blocks';
import { buildNetsuiteInvoiceUrl } from '@/utilities/netsuite';
import { buildBillcomBillUrl } from '@/utilities/billcom';
import { Body2 } from './blocks';

export const RECORD_LABELS = {
    NETSUITE_INVOICE: 'NetSuite invoice',
    NETSUITE_VENDOR_BILL: 'NetSuite vendor bill',
    BILLCOM_BILL: 'Bill.com bill',
};

// Accepts an integrations_outbound row or a preview leg; both carry transaction_type/account_id/transaction_id.
export const recordUrl = (record, invoiceType) =>
    record.transaction_type === 'BILLCOM_BILL'
        ? buildBillcomBillUrl({ billcom_bill_id: record.transaction_id })
        : buildNetsuiteInvoiceUrl({
              netsuite_account_id: record.account_id,
              netsuite_invoice_id: record.transaction_id,
              type: invoiceType,
          });

export const RecordLink = ({ record, invoiceType }) => {
    const url = recordUrl(record, invoiceType);
    if (!url) return record.transaction_id;
    return (
        <OnwardLink href={url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
            {record.transaction_id}
        </OnwardLink>
    );
};

const describeStatus = (record) => {
    if (record.status === 'REVERTED') return `Reverted ${new Date(record.reverted_at).toLocaleString()}`;
    if (record.status === 'REVERT_FAILED') return `Revert failed: ${record.error}`;
    return 'Live';
};

const DownstreamRecords = ({ invoice }) => {
    const records = invoice?.accounting_records || [];
    if (!records.length) return null;
    return (
        <div
            css={css`
                margin-top: 8px;
            `}
        >
            <Body2>Downstream records</Body2>
            {records.map((record) => (
                <Body2 key={record.id}>
                    {RECORD_LABELS[record.transaction_type]} <RecordLink record={record} invoiceType={invoice.type} /> —{' '}
                    {describeStatus(record)}
                </Body2>
            ))}
        </div>
    );
};

export default DownstreamRecords;
